<template>
  <section class="dashboard-view">
    <div class="dashboard-inner-view">
      <div class="right-block">
        <TopbarDefault
          v-if="getAuthenticatedUser"
          @onChangeStatus="onChangeStatus"
        ></TopbarDefault>
        <main class="main-dashboard-view">
          <router-view :layout="layout" />
        </main>
      </div>
    </div>
  </section>
</template>

<script>
import { defineAsyncComponent } from "vue";
const TopbarDefault = defineAsyncComponent(() =>
  import("@/layouts/TopbarDefault")
);

import { mapGetters } from "vuex";
export default {
  name: "home",
  components: {
    TopbarDefault,
  },
  data() {
    return {
      layout: "div",
      isOpen: "",
      routerValue: "",
      clientLogin: false,
    };
  },
  computed: {
    ...mapGetters("auth", ["getAuthenticatedUser", "getAuthenticationDetails"]),
  },
  mounted() {
    this.checkIsAdmin();
  },
  methods: {
    onChangeStatus(data) {
      this.selectedCaseStatus = data.status;
      this.selectedRouteName = data.name;
    },
    checkIsAdmin() {
      if (this.$route.path === "/") {
          this.$router.push({ path: "/signin" });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
